import { EventEmitter } from 'events';

export enum GameState {
    MAIN = 'MAIN',
    MAIN_TO_BONUS = 'MAIN_TO_BONUS',
    BONUS = 'BONUS',
    BONUS_TO_MAIN = 'BONUS_TO_MAIN',
}

interface StateUpdate {
    bet?: number;
    state?: GameState;
    balance?: number;
    freespins?: number;
    soundOn?: boolean;
    fastOn?: boolean;
}

export class GlobalState extends EventEmitter {
    // Private static instance for singleton
    private static instance: GlobalState;

    // Private fields
    private _bet: number = 10; // Default bet amount
    private _state: GameState = GameState.MAIN;
    private _balance: number = 1000; // Initial balance
    private _freespins: number = 0; // Initial freespins
    private _soundOn: boolean = true;
    private _fastOn: boolean = false;

    // Private constructor to prevent instantiation
    private constructor() {
        super();
    }

    // Public getter methods for readonly fields
    public get bet(): number {
        return this._bet;
    }

    public get state(): GameState {
        return this._state;
    }

    public get balance(): number {
        return this._balance;
    }

    public get freespins(): number {
        return this._freespins;
    }

    public get soundOn(): boolean {
        return this._soundOn;
    }

    public get fastOn(): boolean {
        return this._fastOn;
    }

    // Static method to get the singleton instance
    public static getInstance(): GlobalState {
        if (!GlobalState.instance) {
            GlobalState.instance = new GlobalState();
        }
        return GlobalState.instance;
    }

    // Method to update state
    public updateState(data: StateUpdate): void {
        Object.keys(data).forEach((key) => {
            if (data.hasOwnProperty(key)) {
                (this as any)[`_${key}`] = (data as any)[key];
            }
        });

        // Emit an 'update' event with the instance itself
        this.emit('update', this);
    }
}
